import React from 'react';
import { get } from 'lodash-es';
import { useFormContext } from 'react-form';
import { TypedInput } from '@hummingbirdtechgroup/wings-ui';
import { InputWrapper } from '..';
const PasswordInput = (props) => (React.createElement(TypedInput, { type: "password", ...props }));
const ControlledPasswordInput = (props) => {
    const newProps = { ...props };
    const formInstance = useFormContext();
    if (props.sisterField) {
        const { validations = [], sisterField } = props;
        const arePasswordsEqual = {
            message: 'Passwords must be equal',
            isValid: value => get(formInstance, `values[${sisterField}]`, '') === value,
        };
        newProps.validations = [...validations, arePasswordsEqual];
    }
    return (React.createElement(InputWrapper, { ...newProps },
        React.createElement(PasswordInput, null)));
};
PasswordInput.Controlled = ControlledPasswordInput;
export default PasswordInput;
//# sourceMappingURL=PasswordInput.js.map